import { faArrowRightFromBracket as LogoutIcon } from '@fortawesome/pro-light-svg-icons/faArrowRightFromBracket'
import { faCircleQuestion as HelpIcon } from '@fortawesome/pro-light-svg-icons/faCircleQuestion'

import { faFolder as FolderIcon } from '@fortawesome/pro-light-svg-icons/faFolder'

import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { VariationTypes } from '@space-core/components/customButton/types'
import type { DropdownItemProps } from '@space-core/components/dropdown/types'
import useTranslation from '@space-core/hooks/useTranslation'

import type { useHeaderEventHandlers } from './useHeaderEventHandlers'

export function useHeaderDropdownItems(handlers: ReturnType<typeof useHeaderEventHandlers>) {
  const { t } = useTranslation()

  const publicItems: DropdownItemProps[] = [
    {
      label: t('general.register.link'),
      handleClick: () => handlers.handleSignUp('click_signup'),
      variation: VariationTypes.SECONDARY
    },
    {
      label: t('general.signin'),
      handleClick: () => handlers.handleSignIn('click_login'),
      variation: VariationTypes.PRIMARY
    }
  ]

  const privateItems: DropdownItemProps[] = [
    {
      label: t('general.my_account'),
      handleClick: handlers.handleMyAccount,
      iconCustom: faUser
    },
    {
      label: t('general.my_purchases'),
      handleClick: handlers.handleMyPurchases,
      iconCustom: FolderIcon
    },
    { label: t('general.help'), handleClick: handlers.handleHelpClick, iconCustom: HelpIcon },
    { label: t('general.signout'), handleClick: handlers.handleLogout, iconCustom: LogoutIcon }
  ]

  return { publicItems, privateItems } as const
}
